import React, { useEffect, useState } from 'react';
import { AiOutlineArrowRight } from 'react-icons/ai';
import { emailRegex } from 'utils/regex';
import { ReactComponent as IconSuccess } from 'assets/icons/icon-success.svg';

import {
  Container,
  Header,
  Left,
  Title,
  CloseIcon,
  Content,
  InputEmail,
  IconEmail,
  SubTitle,
  ButtonNext,
  SuccessContainer,
  IconSuccessContainer,
  SuccessMsg,
} from './styles';

interface ModalSendMailContractProps {
  email: string;
  setEmail: React.Dispatch<React.SetStateAction<string>>;
  close: () => void;
  sendMail: () => void;
  isLoading: boolean;
  setMailSuccess: React.Dispatch<React.SetStateAction<boolean>>;
  mailSuccess: boolean;
}

const ModalSendMailContract: React.FC<ModalSendMailContractProps> = ({
  email,
  setEmail,
  close,
  sendMail,
  isLoading,
  setMailSuccess,
  mailSuccess,
}) => {
  const [error, setError] = useState(false);
  const [changedEmail, setChangedEmail] = useState(false);

  useEffect(() => {
    if (!email) return setError(false);
    return setError(!emailRegex.test(email));
  }, [email]);

  useEffect(() => {
    if (email || changedEmail) return;
    const emailStorage =
      localStorage.getItem('@UltragazEmpresarial:loginEmail') || '';
    setEmail(emailStorage);
  }, [email, changedEmail, setEmail]);

  return (
    <Container>
      <Header>
        <Left>
          {(!mailSuccess || (mailSuccess && isLoading)) && (
            <>
              <Title>Informe o email</Title>
              <SubTitle>
                Para qual email deseja enviar o(s) arquivo(s).
              </SubTitle>
            </>
          )}
        </Left>
        <CloseIcon
          style={{
            marginTop: '-30px',
          }}
          title="Fechar"
          className="mdi mdi-close"
          onClick={() => {
            setMailSuccess(false);
            close();
          }}
        />
      </Header>
      <Content>
        {(!mailSuccess || (mailSuccess && isLoading)) && (
          <>
            <InputEmail
              labelText="Insira seu email*"
              inputType="text"
              inputName="email"
              inputId="email"
              value={email}
              onChange={(e: any) => {
                setEmail(e.target.value);
                setChangedEmail(true);
              }}
              icon={IconEmail}
              msgError={error ? 'Forneça um email válido' : ''}
            />
            <ButtonNext
              buttonType={
                email && !error && !isLoading ? 'primary' : 'disabled'
              }
              disabled={!email || error || isLoading}
              iconRight={AiOutlineArrowRight}
              onClick={sendMail}
            >
              {isLoading ? 'Aguarde...' : 'Enviar'}
            </ButtonNext>
          </>
        )}
        {mailSuccess && !isLoading && (
          <>
            <SuccessContainer>
              <IconSuccessContainer>
                <IconSuccess />
              </IconSuccessContainer>
              <SuccessMsg>Arquivo(s) enviado(s) com sucesso!</SuccessMsg>
            </SuccessContainer>
            <ButtonNext
              onClick={() => {
                setMailSuccess(false);
                close();
              }}
            >
              OK
            </ButtonNext>
          </>
        )}
      </Content>
    </Container>
  );
};

export default ModalSendMailContract;
